"use client";
import {
  __async
} from "../../../chunk-MMUBH76A.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { ON_RAMP_PROVIDERS } from "../../constants/constants.js";
import styled from "styled-components";
import { CpslButton, CpslIcon, CpslSpinner, CpslText } from "@getpara/react-components";
import { motion } from "framer-motion";
const OnRampProviderButton = ({ config, index, onClick: _onClick }) => {
  const [isLoading, setIsLoading] = useState(false);
  const provider = config.providers[index];
  const { feeLower, feeUpper, name, icon, backgroundColors } = ON_RAMP_PROVIDERS[provider];
  const feeString = `Fee ${feeLower}% - ${feeUpper}%`;
  const onClick = () => __async(void 0, null, function* () {
    setIsLoading(true);
    yield _onClick();
    setIsLoading(false);
  });
  return /* @__PURE__ */ jsx(StyledButton, { $gradientColors: backgroundColors, fullWidth: true, onClick, children: /* @__PURE__ */ jsxs(Container, { $backgroundColor: backgroundColors[1], children: [
    /* @__PURE__ */ jsx(IconContainer, { children: /* @__PURE__ */ jsx(CpslIcon, { icon }) }),
    /* @__PURE__ */ jsxs(ProviderInfoContainer, { children: [
      /* @__PURE__ */ jsx(Text, { variant: "bodyL", weight: "medium", children: name }),
      /* @__PURE__ */ jsx(ProviderInfoInnerContainer, { children: /* @__PURE__ */ jsx(Text, { variant: "bodyXS", weight: "medium", children: feeString }) })
    ] }),
    isLoading ? /* @__PURE__ */ jsx(CpslSpinner, { size: 16 }) : /* @__PURE__ */ jsx(Chevron, { icon: "chevronUp" })
  ] }) });
};
const StyledButton = styled(CpslButton)`
  width: 100%;
  --button-primary-background-color: ${({ $gradientColors }) => `linear-gradient(90deg, ${$gradientColors[0]} 0%, ${$gradientColors[1]} 100%)`};
  --button-primary-hover-background-color: ${({ $gradientColors }) => `linear-gradient(90deg, ${$gradientColors[0]} 0%, ${$gradientColors[0]} 100%)`};
  --button-primary-active-background-color: ${({ $gradientColors }) => `linear-gradient(90deg, ${$gradientColors[0]} 0%, ${$gradientColors[0]} 100%)`};
`;
const Container = styled(motion.div)`
  display: flex;
  gap: 8px;
  flex: 1;
  align-items: center;

  & cpsl-spinner {
    --background-color: ${({ $backgroundColor }) => `${$backgroundColor}`};
  }
`;
const ProviderInfoContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 2px;
`;
const ProviderInfoInnerContainer = styled.div`
  display: flex;
  gap: 16px;
`;
const IconContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 100%;
  height: 48px;
  width: 48px;
`;
const Text = styled(CpslText)`
  &::part(text-element) {
    color: #fff;
  }
`;
const Chevron = styled(CpslIcon)`
  transform: rotate(90deg);
  --icon-color: #fff;
`;
export {
  OnRampProviderButton
};
